import { AuthProvider } from 'providers';
import { Navigate } from 'react-router-dom';
import { App } from 'app';
import { AdminRoutes } from './admin';
import { AnalyticsRoutes } from './analytics';
import { ComplianceRoutes } from './compliance';
import { DashboardRoutes } from './dashboard';
import { ItemRoutes } from './item';
import { MarketingRoutes } from './marketing';
import { OrdersRoutes } from './orders';
import { ReportsRoutes } from './reports';
import { StyleRoutes } from './style';
import { ExampleRoutes } from './example';
import { ErrorBoundary } from 'components';
import { TaskboardRoutes } from './taskboard';
import { SuppliersRoutes } from './suppliers';
import { PurchaseOrderRoutes } from './purchase-orders';
import { SupplierRoutes } from './supplier';
import { useOrgType } from 'features/accessControl';

const DefaultRoute = () => {
  const isSupplier = useOrgType(2);
  if (isSupplier) {
    return <Navigate to="/suppliers" replace />;
  }
  return <Navigate to="/taskboard?sort=deadline&order=ASC" replace />;
};

export const AppRoutes = [
  {
    path: '/',
    element: (
      <ErrorBoundary showDialog={false} dialogShouldRefresh={false}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    ),
    children: [
      {
        path: '/',
        element: <DefaultRoute />,
      },
      DashboardRoutes,
      StyleRoutes,
      ItemRoutes,
      OrdersRoutes,
      ReportsRoutes,
      AnalyticsRoutes,
      MarketingRoutes,
      ComplianceRoutes,
      AdminRoutes,
      ExampleRoutes,
      TaskboardRoutes,
      SuppliersRoutes,
      PurchaseOrderRoutes,
      SupplierRoutes,
    ],
  },
];
